import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SkillsSection = ({ deployedSkills = [], associateSkills = [] }) => {
  const theme = useTheme();
  const t = theme.custom;

  const deployedIds = new Set(deployedSkills.map((s) => s.skillId));

  if (associateSkills.length === 0 && deployedSkills.length === 0) {
    return (
      <Typography sx={{ fontSize: "11px", color: t.text3, fontStyle: "italic" }}>
        No skills on profile
      </Typography>
    );
  }

  // If we have associateSkills, show all with deployed ones highlighted
  const skillsToShow = associateSkills.length > 0 ? associateSkills : deployedSkills;

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px", mb: "4px" }}>
        {skillsToShow.map((sk) => {
          const isDeployed = deployedIds.has(sk.skillId);
          return (
            <Box
              key={sk.skillId}
              sx={{
                background: isDeployed ? t.accent2 : t.surface2,
                border: `1px solid ${isDeployed ? t.accent + "44" : t.border2}`,
                borderRadius: "2px",
                padding: "2px 8px",
              }}
            >
              <Typography sx={{ fontSize: "11px", color: isDeployed ? t.accent : t.text3 }}>
                {isDeployed ? "✓ " : ""}{sk.skillName}
              </Typography>
            </Box>
          );
        })}
      </Box>
      <Typography sx={{ fontSize: "10px", color: t.text3, fontStyle: "italic", mt: "4px" }}>
        ✓ — deployed on this position · others from Zoho profile
      </Typography>
    </>
  );
};

export default SkillsSection;